import React, { useState, useEffect } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import { useTheme } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
import Hidden from '@material-ui/core/Hidden';

import logo from '../../assets/images/logo.png'

function ElevationScroll(props) {
    const { children } = props;

    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

const useStyles = makeStyles(theme => ({
    toolbarMargin: {
        ...theme.mixins.toolbar,
        marginBottom: "0em",
        [theme.breakpoints.down("md")]: {
            marginBottom: "0em"
        },
        [theme.breakpoints.down("xs")]: {
            marginBottom: "0em"
        }
    },
    logo: {
        height: "8em",
        [theme.breakpoints.down("md")]: {
            height: "7em"
        },
        [theme.breakpoints.down("sm")]: {
            height: "7em"
        },
        [theme.breakpoints.down("xs")]: {
            height: "5.5em"
        }
    },
    logoContainer: {
        padding: 0,
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    tabContainer: {
        marginLeft: "auto",
    },
    tab: {
        fontWeight: 500,
        color: "white",
        fontSize: "1rem",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "none",
        }
    },
    button: {

        ...theme.typography.estimate,
        borderRadius: "0px",
        paddingLeft: "45px",
        marginTop: "-1px",
        height: "113px",
        width: "200px",
        textDecoration: "none !important",
        boxShadow: "none",
        backgroundImage: theme.palette.common.bgGrad1,
        clipPath: "polygon(0% 0%, 100% 0%, 75% 100%, 0% 100%)",
        justifyContent: "flex-end",
        transition: "0.5s",
        [theme.breakpoints.down("md")]: {
            height: "100px",
        },

        "&:before": {
            backgroundImage: theme.palette.common.bgGrad2,
            content: "' '",
            display: "block",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: "100%",
            zIndex: "-100",
            transition: "opacity 0.5s",
        },

        "&:hover": {
            clipPath: "polygon(0% 0%, 75% 0%, 100% 100%, 0% 100%)",

            "&:before": {
                opacity: 1,
            },

        },

    },
    menu: {
        backgroundColor: theme.palette.common.blue,
        color: "white",
        borderRadius: "0px",
        zIndex: 1302
    },
    menuItem: {
        ...theme.typography.tab,
        opacity: 0.7,
        "&:hover": {
            opacity: 1
        }
    },
    drawerIcon: {
        height: "50px",
        width: "50px"
    },
    drawerIconContainer: {
        marginLeft: "auto",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    drawer: {
        backgroundColor: theme.palette.common.blue,
        backgroundImage: `linear-gradient(to right, #71c2f9,${theme.palette.primary.main} )`,
        width: "33%",
        marginTop: "2.1em",
        [theme.breakpoints.down("xs")]: {
            marginTop: "1.3em",
        },
    },
    drawerItem: {
        ...theme.typography.tab,
        color: "white",
        opacity: 0.7,
    },
    drawerItemEstimate: {
        backgroundColor: theme.palette.common.orange
    },
    drawerItemSelected: {
        "& .MuiListItemText-root": {
            opacity: 1
        }
    },
    appbar: {
        zIndex: theme.zIndex.modal + 1,
        backgroundImage: theme.palette.common.bgGrad3,
    },
    root: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        zIndex: 1303
    },
}))

export default function Header(props) {
    const classes = useStyles();
    const theme = useTheme();
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
    const content = props.content.header;
    const language = props.language;

    const [openDrawer, setOpenDrawer] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openMenu, setOpenMenu] = useState(false);

    const handleChange = (e, newValue) => {
        props.setValue(newValue);
    }

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
        setOpenMenu(true);
    }

    const handleMenuItemClick = (e, i) => {
        setAnchorEl(null);
        setOpenMenu(false);
        props.setSelectedIndex(i);
    }

    const handleClose = (e) => {
        setAnchorEl(null);
        setOpenMenu(false);
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenMenu(false);
            // setOpen(false);
        }
    }

    function ScrollTop(props) {
        const { children, window } = props;
        const classes = useStyles();

        const trigger = useScrollTrigger({
            target: window ? window() : undefined,
            disableHysteresis: true,
            threshold: 100,
        });

        const handleClickTop = (event) => {
            const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

            if (anchor) {
                anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        return (
            <Zoom in={trigger}>
                <div onClick={handleClickTop} role="presentation" className={classes.root}>
                    {children}
                </div>
            </Zoom>
        );
    }

    const menuOptions = [
        { name: content.tab2_1, link: "/network", activeIndex: 1, selectedIndex: 0 },
        { name: content.tab2_2, link: "/hardware", activeIndex: 1, selectedIndex: 1 },
        { name: content.tab2_3, link: "/learn", activeIndex: 1, selectedIndex: 2 },
    ];

    const routes = [
        { name: content.tab1, link: "/", activeIndex: 0 },
        {
            name: content.tab2, link: "/services", activeIndex: 1,
            ariaOwns: anchorEl ? "simple-menu" : undefined,
            ariaPopup: anchorEl ? "true" : undefined,
            mouseOver: event => handleClick(event)
        },
        { name: content.tab3, link: "/about", activeIndex: 2 },

    ];

    useEffect(() => {
        [...menuOptions, ...routes].forEach(route => {
            switch (window.location.pathname.replaceAll('/', '')) {
                case `${route.link.replaceAll('/', '')}`:
                    if (props.value !== route.activeIndex) {
                        props.setValue(route.activeIndex)
                        if (route.selectedIndex && route.selectedIndex !== props.selectedIndex) {
                            props.setSelectedIndex(route.selectedIndex)
                        }
                    }
                    break;

                case 'contact':
                    if (props.value !== 3) {
                        props.setValue(false);
                    }
                    break;

                default:
                    break;
            }
        })

    }, [props.value, menuOptions, props.selectedIndex, routes, props]);

    const tabs = (
        <React.Fragment>
            <Tabs
                value={props.value}
                onChange={handleChange}
                className={classes.tabContainer}
                indicatorColor="secondary"
            >
                {routes.map((route, index) => (
                    <Tab
                        key={`${route}${index}`}
                        className={classes.tab}
                        component={Link}
                        to={route.link}
                        label={route.name}
                        aria-owns={route.ariaOwns}
                        aria-haspopup={route.ariaPopup}
                        onMouseOver={route.mouseOver}
                        onMouseLeave={() => setOpenMenu(false)}
                    />
                ))}
            </Tabs>
            <Button component={Link} to="/contact" onClick={() => props.setValue(false)} variant="contained" color="primary" className={classes.button}>
                {content.tab6}
            </Button>

            <Popper open={openMenu} anchorEl={anchorEl} placement="bottom" role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: "top" }}
                    >
                        <Paper classes={{ root: classes.menu }} elevation={0}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList onMouseOver={() => setOpenMenu(true)} onMouseLeave={handleClose} disablePadding autoFocusItem={false} id="simple-menu" onKeyDown={handleListKeyDown}>
                                    {menuOptions.map((option, i) => (
                                        <MenuItem key={`${option}${i}`}
                                            dir={language === "per" ? "rtl" : null}
                                            component={Link}
                                            to={option.link}
                                            classes={{ root: classes.menuItem }}
                                            onClick={(event) => { handleMenuItemClick(event, i); props.setValue(1); handleClose() }}
                                            selected={i === props.selectedIndex && props.value === 1 && window.location.pathname !== "/services"}
                                        >
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

        </React.Fragment>
    )

    const drawer = (
        <React.Fragment>
            <SwipeableDrawer
                anchor='right'
                disableBackdropTransition={!iOS}
                disableDiscovery={iOS}
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                onOpen={() => setOpenDrawer(true)}
                classes={{ paper: classes.drawer }}
            >
                <div className={classes.toolbarMargin} />
                <List disablePadding>
                    {routes.map(route =>
                        <ListItem
                            key={`${route}${route.activeIndex}`}
                            onClick={() => { setOpenDrawer(false); props.setValue(route.activeIndex) }}
                            divider
                            button
                            component={Link}
                            to={route.link}
                            selected={props.value === route.activeIndex}
                            classes={{ selected: classes.drawerItemSelected }}
                            style={{ textAlign: "right" }}
                        >
                            <ListItemText
                                className={classes.drawerItem}
                                disableTypography
                            >
                                {route.name}
                            </ListItemText>
                        </ListItem>
                    )}

                    <ListItem
                        onClick={() => { setOpenDrawer(false); props.setValue(false) }}
                        classes={{ root: classes.drawerItemEstimate, selected: classes.drawerItemSelected }}
                        selected={props.value === 5}
                        divider
                        button
                        component={Link} to="/contact"
                        style={{ textAlign: "right" }}
                    >
                        <ListItemText className={classes.drawerItem} disableTypography>
                            {content.tab6}
                        </ListItemText>
                    </ListItem>
                </List>
            </SwipeableDrawer>
            <IconButton className={classes.drawerIconContainer} onClick={() => setOpenDrawer(!openDrawer)} disableRipple>
                <MenuIcon className={classes.drawerIcon} />
            </IconButton>
        </React.Fragment >
    )

    return (
        <React.Fragment>

            {/* Scroll Top */}
            <Toolbar id="back-to-top-anchor" />
            <ScrollTop >
                <Fab color="secondary" size="small" aria-label="scroll back to top" style={{ borderRadius: 0, color: theme.palette.primary.main, backgroundImage: theme.palette.common.bgGrad1 }}>
                    <KeyboardArrowUpIcon />
                </Fab>
            </ScrollTop>

            <ElevationScroll>
                <AppBar position="fixed" className={classes.appbar} dir={language === "per" ? "rtl" : null}>
                    <Toolbar disableGutters >

                        <Hidden smDown>
                            <Button
                                component={Link}
                                to="/"
                                disableRipple
                                onClick={() => props.setValue(0)}
                                className={classes.logoContainer}
                            >

                                <img alt="companny logo" className={classes.logo} src={logo} />
                            </Button>
                            {tabs}
                        </Hidden>
                        <Hidden mdUp>
                            <Grid container direction="row" justify="space-between" alignItems="center">
                                <Button
                                    component={Link}
                                    to="/"
                                    disableRipple
                                    onClick={() => props.setValue(0)}
                                    className={classes.logoContainer}
                                >

                                    <img alt="companny logo" className={classes.logo} src={logo} />
                                </Button>
                                <Grid item>
                                    <Grid item container justify="flex-start">
                                        {drawer}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Hidden>


                    </Toolbar>
                </AppBar>
            </ElevationScroll>
            <div className={classes.toolbarMargin} />
        </React.Fragment>
    )
}